import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { providerCapability } from "../_types/provider-capability.model";

@Injectable({
    providedIn: 'root',
})
export class ProviderCapabilitiesService extends Service<providerCapability> {
  public override type = 'providerCapabilities';
  public override url = 'providers/providerCapabilities'; 
}